import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Icon = ({ name, className }) => (<i className={classNames({
  'icon-component': true,
  [`icon-${name}`]: true,
  [className]: className,
})} />);

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Icon.defaultProps = {
  className: '',
};

export default Icon;
